import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions/shared/index/filter';
import Filter from '../../shared/index/filters';
import DefaultEventsView from './DefaultEventsView/DefaultEventsView';

const handleNoCreatorId = creator => {
  let option = null;
  if (creator.id !== null) {
    option = (
      <option key={creator.id} value={creator.id}>
        {creator.name}
      </option>
    );
  }
  return option;
};

const handleNoTrainerId = trainer => {
  let option = null;
  if (trainer.id !== null) {
    option = (
      <option key={trainer.id} value={trainer.id}>
        {trainer.name}
      </option>
    );
  }
  return option;
};

const EventsFilters = ({
  trainers,
  eventCreators,
  selectedInstructor,
  selectedPastOrUpcoming,
  selectedCreator,
  filterUpdateCreator,
  filterUpdateInstructor,
  filterUpdatePastOrUpcoming,
}) => (
  <Filter.Toolbar>
    <Filter.Select
      selectedValue={selectedPastOrUpcoming}
      selectCallback={value => filterUpdatePastOrUpcoming(value)}
      aria-label="Event Status Filter"
    >
      <option value="any">
        {t('in_person_training.events_dashboard.all_events')}
      </option>
      <option
        value={t(
          'in_person_training.events_dashboard.filtered_upcoming_events',
        )}
      >
        {t('in_person_training.events_dashboard.filtered_upcoming_events')}
      </option>
      <option
        value={t('in_person_training.events_dashboard.filtered_past_events')}
      >
        {t('in_person_training.events_dashboard.filtered_past_events')}
      </option>
    </Filter.Select>
    <Filter.Select
      label="Creator"
      aria-label="Creator Filter"
      selectedValue={selectedCreator}
      selectCallback={value => filterUpdateCreator(value)}
    >
      {!!selectedCreator && <option value="any">All Creators</option>}
      <option disabled>─</option>
      {eventCreators.results.map(creator => handleNoCreatorId(creator))}
    </Filter.Select>
    <Filter.Select
      aria-label="Instructor Filter"
      label="Instructor"
      selectedValue={selectedInstructor}
      selectCallback={value => filterUpdateInstructor(value)}
    >
      {!!selectedInstructor && <option value="any">All Instructors</option>}
      {!!selectedInstructor && <option disabled>─</option>}
      {trainers.map(trainer => handleNoTrainerId(trainer))}
    </Filter.Select>
    <>
      <DefaultEventsView />
    </>
  </Filter.Toolbar>
);

const mapStateToProps = ({
  filter,
  data: { content, trainers, eventCreators },
}) => ({
  events: content,
  selectedInstructor: filter.instructor,
  selectedPastOrUpcoming: filter.pastOrUpcoming,
  selectedCreator: filter.creator,
  trainers,
  eventCreators,
});

const mapDispatchToProps = dispatch => ({
  filterUpdateCreator: creator =>
    dispatch(actions.filterUpdateCreator(creator)),
  filterUpdateInstructor: instructor =>
    dispatch(actions.filterUpdateInstructor(instructor)),
  filterUpdatePastOrUpcoming: pastOrUpcoming =>
    dispatch(actions.filterUpdatePastOrUpcoming(pastOrUpcoming)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventsFilters);
